const recaps = [
  { id: "2025-06-15", title: "June 15, 2025 - Father's Day Special" },
  { id: "2025-06-22", title: "June 22, 2025 - Gator vs. Seminole Lake CC" },
  { id: "2025-07-06", title: "July 6, 2025 - Sherman Hills Showdown" },
  { id: "2025-07-13", title: "July 13, 2025 - Jamey's Birthday Bash at Bardmoor" },
  { id: "2025-07-20", title: "July 20, 2025 - Bugs, Beers, and Buffalo Creek" },
  { id: "2025-07-27", title: "July 27, 2025 - Toes out and Temps up at Hernando Oaks" },

  { id: "2025-08-03", title: "August 3, 2025 - Seminole Lake - Who the F is JD?" },
  { id: "2025-08-10", title: "August 10, 2025 - The Rich Gets Richer at Huntington Hills" },
  { id: "2025-08-17", title: "August 17, 2025 - Diamond Hill Disasterpiece" },
  { id: "2025-09-07", title: "September 7, 2025 - Romeo Rocks the Major, King Jamey Steals the Throne at Fox Hollow" },
  { id: "2025-09-14", title: "September 14, 2025 - Buffalo Creek Blowout Shorts Goes Long" },

];

export default recaps;
